import { FormControl, FormGroupDirective, NgForm } from '@angular/forms';
import { ErrorStateMatcher } from '@angular/material/core';
import { ValidationError } from '../../../domain/error.model';


export class LsnErrorStateMatcher implements ErrorStateMatcher {

    component: ErrorAwareComponent;
    fields: string[];

    constructor(component: ErrorAwareComponent, fields: string | string[]) {
        this.component = component;
        if (fields instanceof Array) {
            this.fields = fields;
        } else {
            this.fields = [fields];
        }
    }

    get errors(): ValidationError[] {
        return this.component.errors.filter(element => this.fields.indexOf(element.field) !== -1);
    }

    isErrorState(control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {
        return this.errors.length > 0;
    }
}

export interface ErrorAwareComponent {
    errors: ValidationError[];
}
